import AbstractEntity from "../AbstractEntity";

export default class Intervention extends AbstractEntity {
    static STATUS_IN_PROGRESS = 0;
    static STATUS_SUCCESS = 1;
    static STATUS_FAILED = 2;
    static STATUS_FORCED_SUCCESS = 3;

    _id;
    _companyId;
    _artisanId;
    _status;
    _invoiceFileId;
    _invoicePreTaxAmount;
    _token;
    _suggestionId;
    _orderId;
    _artisanCommentsId;


    getId() {
        return this._id;
    }

    getCompanyId() {
        return this._companyId;
    }

    getArtisanId() {
        return this._artisanId;
    }

    getStatus() {
        return this._status;
    }

    getInvoiceFileId() {
        return this._invoiceFileId;
    }

    getInvoicePreTaxAmount() {
        return this._invoicePreTaxAmount;
    }

    getToken() {
        return this._token;
    }

    getSuggestionId() {
        return this._suggestionId;
    }

    getOrderId() {
        return this._orderId;
    }

    getArtisanCommentsId() {
        return this._artisanCommentsId;
    }

    getClassName() {
        return "intervention";
    }
}